export enum ErrorTypeValidationEnum {
    MinLength = 'minlength',
    MaxLength = 'maxlength',
    Requirido = 'required',
    Invalido = 'invalid' ,
    ValidarRegex = 'pattern'
}